import { createContext, type ReactNode, useContext, useState } from "react";

type ActiveField = {
  field: number;
  isIgnoreRows: boolean;
} | null;

interface ITemplateStateContextProps {
  selectedField?: ActiveField;
  updateSelectedField: (field: ActiveField) => void;
}

interface ITemplateStateProviderProps {
  children: ReactNode;
}

const TemplateStateContext = createContext<ITemplateStateContextProps>({
  updateSelectedField: () => {},
} satisfies ITemplateStateContextProps);

export const TemplateStateProvider = ({
  children,
}: ITemplateStateProviderProps) => {
  const [selectedField, setSelectedField] = useState<ActiveField>(null);

  const updateSelectedField = (field: ActiveField) => {
    if (field == null) return;
    setSelectedField((prev) => ({
      ...prev,
      field: field.field,
      isIgnoreRows: field.isIgnoreRows,
    }));
  };

  return (
    <TemplateStateContext.Provider
      value={{
        selectedField,
        updateSelectedField,
      }}
    >
      {children}
    </TemplateStateContext.Provider>
  );
};

export function useTemplate() {
  return useContext(TemplateStateContext);
}
